'use client';

import { type FC, useEffect } from 'react';
import { useLoggedIn } from '@/tracking/use-logged-in';
import type { RootState } from '../app/checkout/(with-tariff-data)/schema';
import { useDataDog } from './use-data-dog-rum';
import { useTrackVirtPathAndPageMetaWithEnergy } from './use-track-virt-path-and-page-meta';

type TrackingProps = {
  dataDogViewName: string;
  state: RootState | Pick<RootState, 'electricityUsage' | 'gasUsage'>;
  virtPathViewName: string;
};

export const Tracking: FC<TrackingProps> = ({ dataDogViewName, state, virtPathViewName }) => {
  const loggedIn = useLoggedIn();

  const isComboCheckout = Boolean(state.gasUsage && state.electricityUsage);
  const energyCheckoutType = isComboCheckout ? 'Bundle' : state.electricityUsage ? 'Electricity' : 'Gas';

  const trackVirtPathAndPageMetaWithEnergy = useTrackVirtPathAndPageMetaWithEnergy(
    isComboCheckout ? 'Strom Gas' : state.electricityUsage ? 'Strom' : 'Gas',
  );

  useDataDog({
    checkout: 'Energy',
    viewName: dataDogViewName,
    energyCheckoutType,
    state,
  });

  useEffect(() => {
    trackVirtPathAndPageMetaWithEnergy('Commodity', (energy) => ({
      virtPagePath: `${loggedIn ? '/serviceview' : ''}/checkout-b2c-${energy.path}-${virtPathViewName.replace(' ', '-').toLocaleLowerCase()}/`,
      virtPageTitle: `${loggedIn ? 'Serviceview ' : ''}Checkout B2C ${energy.title} ${virtPathViewName}`,
    }));
  }, [loggedIn, trackVirtPathAndPageMetaWithEnergy, virtPathViewName]);

  return null;
};
